// extracted by mini-css-extract-plugin
export default {"group":"SelectableGroup_group__R0IPt"};